import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

// icons
import { IoLockClosedOutline, IoSettingsOutline } from "react-icons/io5";
import { GoPerson } from "react-icons/go";
import { FaRegHospital } from "react-icons/fa6";
import { FaRegAddressCard } from "react-icons/fa";

// api
import { getUserInfoFromHearro, getUserProfileImageFromHearro, putUserProfileImageToHearro } from "../../../services/apis/hearro/user";

// assets
import defaultProfile from '../../../assets/images/default_profile.jpeg';


function HearroMyPageMain() {
    const navigate = useNavigate();
    const profileImgRef = useRef(null);

    const [userInfo, setUserInfo] = useState({
        name: "",
        phone: "",
        institution: "",
        department: ""
    })
    const [profileImg, setProfileImg] = useState("");

    function goToWithdrawalPage() {
        navigate("/dtx002/mypage/withdrawal");
    }

    function goToModifyProfilePage() {
        navigate("/dtx002/mypage/modify-profile");
    }

    function goToModifyPWPage() {
        navigate("/dtx002/mypage/modify-pw");
    }

    function goToLoginHistoryPage() {
        navigate("/dtx002/mypage/login-history");
    }

    async function getUserInfoFromAPI() {
        try{
            const res = await getUserInfoFromHearro();
            if(parseInt(res.status/200, 10)===1){
                const newUserInfo = {
                    name: res.data.name || "",
                    phone: res.data.phoneNumber ? `${res.data.phoneNumber.slice(0,3)}-${res.data.phoneNumber.slice(3,res.data.phoneNumber.length-4)}-${res.data.phoneNumber.slice(res.data.phoneNumber.length-4)}` : "",
                    institution: res.data.instName || "",
                    department: res.data.department || ""
                }

                setUserInfo(newUserInfo);
            }
        }catch(err){
            console.error(err);
        }        
    }

    async function getUserProfileImgFromAPI() {
        try{
            const res = await getUserProfileImageFromHearro();
            if(parseInt(res.status/200, 10)===1){
                const imgURL = URL.createObjectURL(res.data);
                setProfileImg(imgURL || "")
            }else {
                throw new Error();
            }
        }catch(err){
            console.error(err);
        }
    }

    const handleClickUploadProfile = () => {
        profileImgRef.current.click();
    }

    const handleUploadProfileImg = async (e) => {
        if(e.target.files && e.target.files[0]){
            const uploadImg = e.target.files[0];
            const formData = new FormData();
            formData.append('imgfile', uploadImg);
            try {
                const res = await putUserProfileImageToHearro(formData);
                if(parseInt(res.status/200, 10)===1 && res.data.uploadStatus==="OK"){
                    getUserProfileImgFromAPI();
                    alert("이미지 업로드에 성공하였습니다.");
                }else{
                    alert('이미지 업로드에 실패하였습니다.');                    
                }
            }catch(err){
                console.error(err);
                alert('이미지 업로드에 실패하였습니다.');
            }
        }
    }

    useEffect(()=>{
        getUserInfoFromAPI();
        getUserProfileImgFromAPI();
    },[])

    return (
        <div className="dashboardContent">
			<div className="dashboardContent__title">
				<span className="dashboardContent__title__content">마이페이지</span>
			</div>
            <div className="mypage_main_wrapper">
                <div className="main_item_wrapper">
                    <div className="item_title">내 정보</div>
                    <div className="item_box">
                        <div className="box_row">
                            <div className="item_label_icon">
                                <div className="profile_image_wrapper">
                                    <div className="profile_image_circle">
                                        <img src={profileImg || defaultProfile} alt="user profile" />                              
                                    </div>
                                    <button
                                        type="button"
                                        className="profile_setting_btn"
                                        onClick={handleClickUploadProfile}
                                        aria-label="Profile Setting Button"
                                    >
                                        <IoSettingsOutline />
                                    </button>
                                    <input
                                        ref={profileImgRef}
                                        type="file"
                                        accept=".png, .jpg, .jpeg"
                                        style={{display: 'none'}}
                                        onInput={handleUploadProfileImg}
                                    />
                                </div>
                            </div>
                            <div className="name_wrapper">
                                <div className="name">{userInfo.name}</div>
                                <div className="phone">{userInfo.phone}</div>
                            </div>
                            <button className="button_withdrawal" onClick={goToWithdrawalPage}>회원탈퇴</button>
                        </div>
                        <div className="row_divider" />
                        <div className="box_row">
                            <div className="item_label_icon">
                                <div className="box_icon">
                                        <FaRegHospital />
                                </div>
                            </div>
                            <div className="item_label">
                                {userInfo.institution}
                            </div>
                        </div>
                        <div className="box_row">
                            <div className="item_label_icon">
                                <div className="box_icon">
                                        <FaRegAddressCard />
                                </div>
                            </div>
                            <div className="item_label">
                                {userInfo.department}
                            </div>
                        </div>
                        <div className="button_wrapper_bottom">
                            <button
                                className="default_button"
                                onClick={goToModifyProfilePage}
                            >수정</button>
                        </div>
                    </div>
                </div>
                <div className="main_item_wrapper">
                    <div className="item_title">이력 관리</div>
                    <div className="item_box">
                        <div className="box_row">
                            <div className="item_label_icon">
                                <div className="box_icon">
                                        <GoPerson />
                                </div>
                            </div>
                            <div className="item_label">
                                로그인 기록
                            </div>
                            <button className="default_button" onClick={goToLoginHistoryPage}>확인</button>
                        </div>
                    </div>
                </div>
                <div className="main_item_wrapper">
                    <div className="item_title">비밀번호</div>
                    <div className="item_box">
                        <div className="box_row">
                            <div className="item_label_icon">
                                <div className="box_icon">
                                        <IoLockClosedOutline />
                                </div>
                            </div>
                            <div className="item_label">
                                비밀번호 변경
                            </div>
                            <button className="default_button" onClick={goToModifyPWPage}>변경</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HearroMyPageMain;